import { useEffect } from "react";
import { getNestedValue, setNestedValue } from "../../../utils/object";
import Input from "../../../components/Input/Input";
import Select from "../../../components/Select/Select";
import { HikvisionNtpAddressTypeEnum, HikvisionNtpAddressTypeText, HikvisionAuthenticationType, HikvisionAuthenticationTypeText, HikvisionTimeoutActionEnum, HikvisionTimeoutActionText, HikvisionTypeEnum, HikvisionTypeText } from "../../../constants/readers-model";
import ToggleButton from "../../../components/ToggleButton/ToggleButton";

export function PartialFormHikvision({ configuration, setConfiguration, setEditablePort, ...props }) {
   useEffect(() => {
      setEditablePort(true);
      if (!configuration) {
         setConfiguration({
            type: HikvisionTypeEnum.FACIAL,
            authenticationType: HikvisionAuthenticationType.FACIAL,
         });
      }
   }, []);

   function onChange(field, value) {
      const currentValue = getNestedValue(configuration, field);
      if (currentValue === value) return;
      setConfiguration(setNestedValue({ ...configuration }, field, value));
   }

   return (
      <div className="w-full grid grid-cols-2 gap-2.5">
         <Input
            name="user"
            id="user"
            labelText="Usuário"
            value={configuration?.user}
            onChange={({ target }) => onChange('user', target.value)}
            disabled={props.type === "consulta"}
            required={true}
         />
         <Input
            name="password"
            id="password"
            type="password"
            labelText="Senha"
            value={configuration?.password}
            onChange={({ target }) => onChange('password', target.value)}
            disabled={props.type === "consulta"}
            required={true}
         />
         <Select
            labelText="Tipo"
            value={configuration?.type}
            onChange={({ target }) => onChange('type', target.value)}
            disabled={props.type === "consulta"}
            required={true}
            options={[
               ...Object.entries(HikvisionTypeEnum).map(([key, value]) => ({
                  value,
                  text: HikvisionTypeText[value],
               }))
            ]}
         />
         <Select
            labelText="Tipo de Autenticação"
            value={configuration?.authenticationType}
            onChange={({ target }) => onChange('authenticationType', target.value)}
            disabled={props.type === "consulta"}
            required={true}
            options={[
               ...Object.entries(HikvisionAuthenticationType).map(([key, value]) => ({
                  value,
                  text: HikvisionAuthenticationTypeText[value],
               }))
            ]}
         />
         <Input
            name="eventTimeout"
            id="eventTimeout"
            type="number"
            labelText="Timeout de Evento"
            tooltipVisible={true}
            tooltipText="Eventos registrados após esse tempo em segundos, serão ignorados. (0 = ignorar verificação)"
            value={configuration?.eventTimeout}
            onChange={({ target }) => onChange('eventTimeout', target.value)}
            disabled={props.type === "consulta"}
         />
         <ToggleButton
            style={{ width: 'fit-content', paddingTop: '15px' }}
            label={`Força ajuste Hikvision (BETA)`}
            onChange={(e) => onChange('forceAdjust', e.target.checked)}
            selected={configuration?.forceAdjust}
         />
         <div className="flex flex-col gap-1">
            <ToggleButton
               style={{ width: 'fit-content', paddingTop: '15px' }}
               label={`Leitora em Modo Wiegand 26`}
               onChange={(e) => onChange('wiegand26Mode', e.target.checked)}
               selected={configuration?.wiegand26Mode}
            />
            <ToggleButton
               style={{ width: 'fit-content', paddingTop: '15px' }}
               label={`Leitora com Validação de Máscara`}
               onChange={(e) => onChange('userMaskValidation', e.target.checked)}
               selected={configuration?.userMaskValidation}
            />
            <ToggleButton
               style={{ width: 'fit-content', paddingTop: '15px' }}
               label={`Desabilita Encriptação na Leitora`}
               onChange={(e) => onChange('disableEncryption', e.target.checked)}
               selected={configuration?.disableEncryption}
            />
            <ToggleButton
               style={{ width: 'fit-content', paddingTop: '15px' }}
               label={`Modo Online`}
               onChange={(e) => onChange('modoOnline', e.target.checked)}
               selected={configuration?.modoOnline}
            />
            {configuration?.modoOnline && (
               <div className="grid grid-cols-2 gap-3 mt-3.5!">
                  <Select
                     labelText="Ação de Timeout"
                     value={configuration?.timeoutAction}
                     onChange={({ target }) => onChange('timeoutAction', target.value)}
                     disabled={props.type === "consulta"}
                     required={true}
                     options={[
                        ...Object.entries(HikvisionTimeoutActionEnum).map(([key, value]) => ({
                           value,
                           text: HikvisionTimeoutActionText[value],
                        }))
                     ]}
                  />
                  <Input
                     name="authorizationTimeout"
                     id="authorizationTimeout"
                     type="number"
                     labelText="Timeout de Autorização (s)"
                     value={configuration?.authorizationTimeout}
                     onChange={({ target }) => onChange('authorizationTimeout', target.value)}
                     disabled={props.type === "consulta"}
                     required={true}
                  />
               </div>
            )}
            <ToggleButton
               style={{ width: 'fit-content', paddingTop: '15px' }}
               label={`Habilita NTP na Leitora`}
               onChange={(e) => onChange('ntpEnabled', e.target.checked)}
               selected={configuration?.ntpEnabled}
            />
            {configuration?.ntpEnabled && (
               <div className="grid grid-cols-2 gap-3 mt-3.5!">
                  <Select
                     labelText="Ação de Timeout"
                     value={configuration?.addressType}
                     onChange={({ target }) => onChange('addressType', target.value)}
                     disabled={props.type === "consulta"}
                     required={true}
                     options={[
                        ...Object.entries(HikvisionNtpAddressTypeEnum).map(([key, value]) => ({
                           value,
                           text: HikvisionNtpAddressTypeText[value],
                        }))
                     ]}
                  />
                  <Input
                     name="ntpHost"
                     id="ntpHost"
                     labelText="Endereço Servidor"
                     placeholder="a.ntp.br"
                     value={configuration?.ntpHost}
                     onChange={({ target }) => onChange('ntpHost', target.value)}
                     disabled={props.type === "consulta"}
                     required={true}
                  />
                  <Input
                     name="ntpPort"
                     id="ntpPort"
                     labelText="Porta Servidor"
                     value={configuration?.ntpPort}
                     onChange={({ target }) => onChange('ntpPort', target.value)}
                     disabled={props.type === "consulta"}
                     required={true}
                  />
                  <Input
                     name="ntpInterval"
                     id="ntpInterval"
                     labelText="Intervalo (s)"
                     value={configuration?.ntpInterval}
                     onChange={({ target }) => onChange('ntpInterval', target.value)}
                     disabled={props.type === "consulta"}
                     required={true}
                  />
               </div>
            )}
         </div>
         <div className="flex flex-col gap-1">
            <ToggleButton
               style={{ width: 'fit-content', paddingTop: '15px' }}
               label={`Ignora fabricante digital`}
               onChange={(e) => onChange('ignoreDigitalManufacturer', e.target.checked)}
               selected={configuration?.ignoreDigitalManufacturer}
            />
            <ToggleButton
               style={{ width: 'fit-content', paddingTop: '15px' }}
               label={`Habilita tag pelo teclado`}
               onChange={(e) => onChange('enabledTagByKeyboard', e.target.checked)}
               selected={configuration?.enabledTagByKeyboard}
            />
            <ToggleButton
               style={{ width: 'fit-content', paddingTop: '15px' }}
               label={`Leitor Termográfico`}
               onChange={(e) => onChange('thermographicReader', e.target.checked)}
               selected={configuration?.thermographicReader}
            />
            <ToggleButton
               style={{ width: 'fit-content', paddingTop: '15px' }}
               label={`Habilita Controle de Temperatura`}
               onChange={(e) => onChange('temperatureControlEnabled', e.target.checked)}
               selected={configuration?.temperatureControlEnabled}
            />
            {configuration?.temperatureControlEnabled && (
               <div className="grid grid-cols-2 gap-3 mt-3.5!">
                  <Input
                     name="maxTemperature"
                     id="maxTemperature"
                     type="number"
                     labelText="Limite Temperatura Alta (C)"
                     value={configuration?.maxTemperature}
                     onChange={({ target }) => onChange('maxTemperature', target.value)}
                     disabled={props.type === "consulta"}
                     required={true}
                  />
                  <Input
                     name="minTemperature"
                     id="minTemperature"
                     type="number"
                     labelText="Limite Temperatura Baixa (C)"
                     value={configuration?.minTemperature}
                     onChange={({ target }) => onChange('minTemperature', target.value)}
                     disabled={props.type === "consulta"}
                     required={true}
                  />
               </div>
            )}
         </div>
      </div>
   );
}